import * as types from "./constant"

export const getINSCOMPANYStart = () => {
  return {
    type: types.GET_INSURANCE_COMPANY_START,
  }
}
export const getINSCOMPANYSuccess = payload => {
  return {
    type: types.GET_INSURANCE_COMPANY_SUCCESS,
    payload: payload,
  }
}
export const getINSCOMPANYFail = payload => {
  return {
    type: types.GET_INSURANCE_COMPANY_FAILED,
    payload: payload,
  }
}
export const getINSCOMPANYReset = () => {
  return {
    type: types.GET_INSURANCE_COMPANY_RESET,
  }
}

//Create INSCOMPANY

export const CreateINSCOMPANYStart = (payload) => {
    return {
      type: types.CREATE_INSURANCE_COMPANY_START,
      payload: payload
    }
  }
  export const CreateINSCOMPANYSuccess = payload => {
    console.log(payload)
    return {
      type: types.CREATE_INSURANCE_COMPANY_SUCCESS,
      payload: payload,
    }
  }
  export const CreateINSCOMPANYFail = payload => {
    return {
      type: types.CREATE_INSURANCE_COMPANY_FAILED,
      payload: payload,
    }
  }
  export const CreateINSCOMPANYReset = () => {
    return {
      type: types.CREATE_INSURANCE_COMPANY_RESET,
    }
  }
  
  //Create INSCOMPANY

export const UpdateINSCOMPANYStart = (payload) => {
    return {
      type: types.UPDATE_INSURANCE_COMPANY_START,
      payload: payload
    }
  }
  export const UpdateINSCOMPANYSuccess = payload => {
    return {
      type: types.UPDATE_INSURANCE_COMPANY_SUCCESS,
      payload: payload,
    }
  }
  export const UpdateINSCOMPANYFail = payload => {
    return {
      type: types.UPDATE_INSURANCE_COMPANY_FAILED,
      payload: payload,
    }
  }
  export const UpdateINSCOMPANYReset = () => {
    return {
      type: types.UPDATE_INSURANCE_COMPANY_RESET,
    }
  }


  // DELETE INSCOMPANY :

  export const DeleteINSCOMPANYStart = (payload) => {
    return {
      type: types.DEL_INSURANCE_COMPANY_START,
      payload: payload
    }
  }
  export const DeleteINSCOMPANYSuccess = payload => {
    return {
      type: types.DEL_INSURANCE_COMPANY_SUCCESS,
      payload: payload,
    }
  }
  export const DeleteINSCOMPANYFail = payload => {
    return {
      type: types.DEL_INSURANCE_COMPANY_FAILED,
      payload: payload,
    }
  }
  export const DeleteINSCOMPANYReset = () => {
    return {
      type: types.DEL_INSURANCE_COMPANY_RESET,
    }
  }


  